// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ic-3";
export var downloadButton = "_ic-4";
export var fileContainer = "_ic-9 _ic-7";
export var fileContainerBase = "_ic-7";
export var fileContainerFixedHeight = "_ic-8 _ic-7";
export var fileInfo = "_ic-5";
export var fileInfoWidthRestricted = "_ic-6";
export var fileType = "_ic-1";
export var fileTypeName = "_ic-2";
export var image = "_ic-0";
export var link = "_ic-b";
export var overflowEllipsis = "_ic-a";